import React from 'react';
import { Dropdown } from 'react-bootstrap';
import ListAlt from '@mui/icons-material/ListAlt';
import { JdsMoreToggle } from '../../../components/jds/JdsMoreToggle';

export function DetailListRow({
  id,
  labelPrimary,
  labelSecondary,
  value,
  actionLabel,
  onAction,
}) {
  return (
    <div className="d-flex justify-content-between align-items-center">
      <span>
        {labelPrimary}
        {labelSecondary && (
          <>
            <span style={{ color: 'var(--fg-neutral-subtle)' }}> | </span>
            <span
              style={{
                color: 'var(--fg-neutral-subtle)',
                textDecoration: 'underline',
              }}
            >
              {labelSecondary}
            </span>
          </>
        )}
      </span>
      <div className="d-flex align-items-center" style={{ gap: 12 }}>
        {value && (
          <span style={{ fontWeight: 'var(--fw-semibold)' }}>{value}</span>
        )}
        <Dropdown alignRight>
          <Dropdown.Toggle
            as={JdsMoreToggle}
            variant="outlined"
            size="sm"
            id={id}
            aria-label="Opções"
          />
          <Dropdown.Menu className="dropdown-menu">
            <Dropdown.Item
              className="d-flex align-items-center"
              onClick={onAction}
            >
              <ListAlt fontSize="small" className="mr-2" />
              {actionLabel}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}
